/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeUserPasswordBody
 */
export interface ChangeUserPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordBody
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordBody
     */
    confirmPassword: string;
}

export function ChangeUserPasswordBodyFromJSON(json: any): ChangeUserPasswordBody {
    return ChangeUserPasswordBodyFromJSONTyped(json, false);
}

export function ChangeUserPasswordBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeUserPasswordBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
    };
}

export function ChangeUserPasswordBodyToJSON(value?: ChangeUserPasswordBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'confirmPassword': value.confirmPassword,
    };
}


